"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const selectors_1 = require("@/store/ducks/associatedComponents/selectors");
const removeProductAssociationUseCase_1 = __importDefault(require("@/useCases/productsAssociation/removeProductAssociationUseCase"));
const index_view_1 = __importDefault(require("./index.view"));
function RemoveAssociationDialog({ arrayHelpers }) {
    const { productId } = (0, react_router_dom_1.useParams)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isDialogVisible = (0, react_redux_1.useSelector)(selectors_1.isDeleteAssociationDialogOpenSelctor);
    const componentToBeUnlinked = (0, react_redux_1.useSelector)(selectors_1.componentToBeUnlinkedSelector);
    const rowIndexToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.rowIndexToBeUnlinkedSelector);
    const onClose = react_1.default.useCallback(() => {
        dispatch((0, associatedComponents_1.closeDeleteAssociationModal)());
    }, [associatedComponents_1.closeDeleteAssociationModal]);
    const onProceed = react_1.default.useCallback(() => {
        arrayHelpers.remove(rowIndexToBeDeleted);
        (0, removeProductAssociationUseCase_1.default)(componentToBeUnlinked?.id, productId)(dispatch);
    }, [arrayHelpers, rowIndexToBeDeleted, componentToBeUnlinked, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: isDialogVisible, onClose: onClose, onDismiss: onClose, componentToBeUnlinkedName: componentToBeUnlinked?.name, onProceed: onProceed }));
}
exports.default = react_1.default.memo(RemoveAssociationDialog);
